// Shared group-total maths, used by the canvas backdrop and the report panel.
//
// A group's total is the money that flows INTO its members this month, in the
// ledger's primary currency. Basing it on actual inflows (rather than each
// node's own figure) means it naturally includes a card's payment, a bill's
// amount, a pot's top-up, and anything else wired into a member (such as a
// one-off feeding a loan).
import { convertMinor, type Move } from "@vulpari/core";

/** Money flowing into each node this month, summed in the primary currency.
 * A move's amount is in its source's currency, so it is converted on the way. */
export function incomingInPrimary(
  moves: Move[],
  currencyOf: (id: string) => string,
  primaryCurrency: string,
  rates?: Record<string, number>,
): Map<string, number> {
  const map = new Map<string, number>();
  for (const move of moves) {
    const amount = convertMinor(move.amount, currencyOf(move.fromNodeId), primaryCurrency, rates);
    map.set(move.toNodeId, (map.get(move.toNodeId) ?? 0) + amount);
  }
  return map;
}

/** Sum the money flowing into a group's members this month. */
export function groupTotal(nodeIds: string[], incoming: Map<string, number>): number {
  let total = 0;
  for (const id of nodeIds) {
    total += incoming.get(id) ?? 0;
  }
  return total;
}
